import React from 'react';
import PreviousEventList from '../components/PreviousEventList';

const PreviousEventPage = () => {
    
        return (
            <div data-testid="previousEventPage">
              <PreviousEventList />
            </div>
          );
    }


export default PreviousEventPage;